var _interface = require('util/interface').interface;
var DataType = require('../datatype');

/**
 * JSON data type.
 * <P>
 * Accessed via:
 * <code>diffusion.datatypes.json();</code>
 * <P>
 * For efficiency, the JSON value is serialized in binary form following
 * the CBOR specification.
 * <P>
 * <p>
 * The implementation provides support for binary deltas.
 *
 * JSON instances defer parsing of underlying binary data until required. If the data
 * is not valid, an Error may be thrown when {@link diffusion.datatypes.JSON#get} is called.
 * @class diffusion.datatypes.JSONDataType
 * @augments diffusion.datatypes.DataType
 * @since 5.7
 */
module.exports = _interface('JSONDataType', DataType, [

    /**
     * Returns a new {@link diffusion.datatypes.JSON} instance from a native JS object.
     * <P>
     * Passing a string will produce a JSON instance encoding a single string token. To produce a JSON datatype instance
     * from a JSON string, use {@link diffusion.datatypes.JSONDataType#fromJsonString} instead.
     *
     * @example
     * // Datatype instance from object
     * var value = jsondatatype.from({
     *     foo : "bar",
     *     baz : [1, 2, 3]
     * });
     *
     * @example
     * // Datatype instance from string
     * var value = jsondatatype.from("this is a simple string");
     *
     * @param {Object} object - The object data
     * @return {diffusion.datatypes.JSON} a JSON data-type instance
     *
     * @function diffusion.datatypes.JSONDataType#from
     */
    'from',

    /**
     * Returns a new {@link diffusion.datatypes.JSON} instance from a JSON string.
     * <P>
     * Precision for numeric types is lost in the translation to the internal
     * CBOR binary form and non-significant white space is not preserved.
     *
     * @example
     * // Datatype instance from a JSON string.
     * var value = jsondatatype.fromJsonString("{\"foo\" : \"bar\"}");
     *
     * // The value contains the parsed object representation
     * value.get(); // => { foo : "bar" }
     *
     * @param {String} string - The JSON string
     * @return {diffusion.datatypes.JSON} A JSON data-type instance
     *
     * @function diffusion.datatypes.JSONDataType#fromJsonString
     * @since 5.9
     */
    'fromJsonString'
]);




//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/data/json/json-datatype.js
// module id = 956
// module chunks = 1